export enum PLAYER {
    /**
     * @value Captions
     * @description Title of a menu item in the player to control which caption is displayed by the player
     */
    CAPTIONS = 'PLAY.CAPTIONS',
    /**
     * @value Connecting...
     * @description Used when connecting to the google cast for videos
     */
    CONNECTING_ELIPSIS = 'PLAY.CONNECTING_ELIPSIS',
    /**
     * @value Google Cast
     * @description Google cast feature for player
     */
    GOOGLE_CAST = 'PLAY.GOOGLE_CAST',
    /**
     * @value LumApps Play video player - %TITLE%
     * @description Title of the video iframe
     */
    MAIN_TITLE = 'PLAY.VIDEO_PLAYER_MAIN_TITLE',
    /**
     * @value Quality
     * @description Title of a menu item in the player to control the quality of the video played (ex:1080p)
     */
    QUALITY = 'PLAY.QUALITY',
    /**
     * @value Speed
     * @description Title of a menu item in the player to control the speed of the player
     */
    SPEED = 'PLAY.SPEED',
    /**
     * @value LumApps Play video player
     * @description Title of the video iframe
     */
    TITLE = 'PLAY.VIDEO_PLAYER_TITLE',
    /**
     * @value Watch video
     */
    WATCH_VIDEO = 'PLAY.WATCH_VIDEO',
}
